import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./App.css";

import FeeReceiptUI from "./FeeUI";

const AdminReceipt = () => {
  const { transaction_id } = useParams();
  const [receiptData, setReceiptData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReceiptData = async () => {
      const token = sessionStorage.getItem("authToken");
      const decodedID = atob(transaction_id)
      try {
        console.log("Fetching receipt data...");
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/armedforces-api/admin/getFeeReceipt/${decodedID}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${token}`,
          },
        });
       // console.log("Response status:", response.status);
        const result = await response.json();
       // console.log("Response result:", result);
        if (result.length > 0) {
          setReceiptData(result[0]);
        } else {
          setReceiptData(null);
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching fee receipt:', error);
        setIsLoading(false);
      }
    };

    fetchReceiptData();
  }, [transaction_id]);

 // console.log("Receipt data", receiptData);

 

  return (
    <div>
      <FeeReceiptUI receiptData={receiptData} isLoading={isLoading} />
    </div>
  );
};
export default AdminReceipt;
